import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, Input, ViewChild } from '@angular/core';
import dayjs from 'dayjs';
import { TReminder } from '../../reminders.consts';
import { TReminderEvent } from '../reminder-calendar-consts';

@Component({
  selector: 'pp-reminders-calendar-list',
  templateUrl: './reminders-calendar-list.component.html',
  styleUrl: './reminders-calendar-list.component.scss',
  standalone: false,
})
export class RemindersCalendarListComponent {
  @Input() ppEvents: TReminderEvent[];

  @ViewChild(CdkVirtualScrollViewport)
  viewport!: CdkVirtualScrollViewport;

  reminders: TReminder[];
  scrollSpacerHeight: number;
  todayIndex: number;

  ngOnInit(): void {
    this.setReminders();
  }

  ngOnChanges(): void {
    this.setReminders();
  }

  ngAfterViewInit() {
    this.setScrollSpacing();

    setTimeout(() => {
      this.viewport.scrollToIndex(this.todayIndex, 'smooth');
    }, 500);
  }

  setReminders(): void {
    this.reminders = this.ppEvents
      .map((event) => event.reminder)
      .sort((a, b) => a.timestampEpochMillis - b.timestampEpochMillis);

    this.todayIndex = this.reminders.findIndex((r) =>
      dayjs(r.timestampEpochMillis).isSame(dayjs(), 'day'),
    );

    if (this.viewport) {
      this.setScrollSpacing();
    }
  }

  trackByReminderId(index: number, reminder: TReminder): string {
    return reminder.reminderId;
  }

  private setScrollSpacing(): void {
    const estimatedItemHeight = 30;
    const visibleOffset = 1 / 3;
    const itemCount = this.reminders.length;

    const totalHeight = estimatedItemHeight * itemCount;

    if (this.viewport) {
      this.scrollSpacerHeight = Math.max(
        this.viewport.getViewportSize() * visibleOffset,
        totalHeight * visibleOffset,
      );
    }

    this.viewport.scrollToOffset(this.scrollSpacerHeight);
  }
}
